import React from "react";
import { X } from "lucide-react";
import { Button } from "../ui/button";
import { Reveal, Starburst } from "../common";
import { useLead } from "../LeadDialog";
import { PROBLEMS } from "../../data/site";

const Problems = () => {
  const { openLead } = useLead();
  return (
    <section
      className="relative py-24 md:py-32 bg-jet-ink text-white overflow-hidden"
      data-testid="problems-section"
    >
      <Starburst className="absolute -top-10 right-[10%] h-40 w-40 text-white/[0.04]" />
      <Starburst className="absolute bottom-10 left-[5%] h-24 w-24 text-white/[0.04]" />

      <div className="max-w-[88rem] mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="inline-flex items-center gap-2 text-xs md:text-sm font-bold uppercase tracking-[0.22em] text-jet-amber mb-5">
                <Starburst className="h-3 w-3 text-jet-amber" />
                The Industry Problem
              </div>
              <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
                Tired of cleaning companies that let you down?
              </h2>
              <p className="mt-6 text-white/60 text-lg leading-relaxed max-w-md">
                We built Jet Cleaning Service to fix everything wrong with the
                industry. Cleaning should be dependable, professional, and
                stress-free.
              </p>
              <Button
                onClick={() => openLead("quote")}
                className="mt-8 rounded-full bg-jet-teal hover:bg-jet-teal-deep text-white font-bold h-14 px-8 teal-glow"
                data-testid="problems-cta-button"
              >
                Experience the Difference
              </Button>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pl-10">
            <div className="space-y-1">
              {PROBLEMS.map((p, i) => (
                <Reveal key={p.n} delay={i * 0.08}>
                  <div className="group flex items-center gap-6 py-5 border-b border-white/10">
                    <span className="font-display text-2xl md:text-3xl font-medium text-white/25 w-14">
                      {p.n}
                    </span>
                    <span className="grid place-items-center h-9 w-9 rounded-full bg-red-500/15 text-red-400 shrink-0">
                      <X className="h-5 w-5" strokeWidth={2.5} />
                    </span>
                    <span className="text-xl md:text-2xl font-medium text-white/80 group-hover:text-white transition-colors">
                      {p.text}
                    </span>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.2}>
              <div className="mt-8 rounded-3xl bg-gradient-to-br from-jet-teal to-jet-teal-deep p-8 md:p-10">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/70 mb-2">
                  That's why we built Jet Cleaning Service
                </p>
                <p className="font-display text-2xl md:text-3xl font-semibold leading-snug">
                  Clear communication. Reliable scheduling. Consistent quality.
                  You always know what to expect.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problems;
